<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <form class="form-horizontal" @submit.prevent="$emit('submit', data)">
        <SelectFormGroup
            v-model="data.driver"
            name="driver"
            label="Block Type"
            :error="(errors.driver || [])[0]"
            :options="blockTypeOptions"
        />

        <BaseForm
            v-if="data.driver"
            v-model="data.driver_parameters"
            :driver="data.driver"
            :errors="driverErrors"
            :portal="portal"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import BaseForm from '@/components/Panels/Administration/MarketingSites/Blocks/DriverForms/Base'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {BaseForm, SelectFormGroup, SubmitFormGroup},

  props: {
    value: {
      required: false,
      default: () => ({driver_parameters: {}})
    },

    portal: {
      required: true
    },

    errors: {
      required: true
    },

    blockTypes: {
      required: true
    }
  },

  data() {
    return {
      data: {...this.value}
    }
  },

  computed: {
    blockTypeOptions() {
      return this.blockTypes.map(blockType => ({value: blockType.id, label: blockType.attributes.name}))
    },

    driverErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('driver_parameters.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('driver_parameters.'.length)]: entry[1]
          }), {})
    }
  },

  watch: {
    value() {
      this.data = {...this.value}
    }
  }
}
</script>
